import { render, staticRenderFns } from "./PlantSingleCard.vue?vue&type=template&id=036c7492&scoped=true"
import script from "./PlantSingleCard.vue?vue&type=script&lang=js"
export * from "./PlantSingleCard.vue?vue&type=script&lang=js"
import style0 from "./PlantSingleCard.vue?vue&type=style&index=0&id=036c7492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c7492",
  null
  
)

export default component.exports